import { ReducerRegistry } from 'store';
import {
  UPDATE_MERCHANT_ID,
  FETCH_WALLET_HISTORY_LOG,
  UPDATE_WALLLET_HISTORY_FILTERS,
  UPDATE_WALLLET_HISTORY_PAGINATION,
  WALLET_HISTORY_ASYNC_START,
  CLEAR,
} from '../types';

const initialState = {
  merchantId: '',
  walletHistory: {
    data: [],
    meta: {},
    pagination: { page: 1, limit: 20 },
    filters: {},
    inProgress: false,
    error: '',
  },
};

export const MerchantId = ReducerRegistry.register(
  'walletHistory',
  (state = initialState, { type, payload, subType }) => {
    switch (type) {
      case UPDATE_MERCHANT_ID:
        return {
          ...state,
          merchantId: payload,
        };
      case FETCH_WALLET_HISTORY_LOG:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            data:
              state[subType].pagination.pagination > 0
                ? [...state[subType].data, ...payload.data]
                : payload.data,
            meta: payload.meta,
            inProgress: false,
          },
        };
      case WALLET_HISTORY_ASYNC_START:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: true,
          },
        };
      case UPDATE_WALLLET_HISTORY_PAGINATION:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            pagination: {
              ...state[subType].pagination,
              page: payload,
            },
          },
        };
      case UPDATE_WALLLET_HISTORY_FILTERS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            filters: payload,
            pagination: initialState[subType].pagination,
          },
        };

      case CLEAR:
        return initialState;

      default:
        return state;
    }
  }
);
